import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class IsRole extends Component {
    static propTypes = {
        children: PropTypes.node,
        session: ImmutablePropTypes.map.isRequired,
        component: PropTypes.node.isRequired,
        role: PropTypes.oneOfType([
            PropTypes.oneOf(['guest', 'user', 'admin']),
            PropTypes.arrayOf(PropTypes.oneOf(['guest', 'user', 'admin'])),
        ]).isRequired,
    }

    static defaultProps = {
        component: 'div',
    }

    _getRole() {
        const { session } = this.props;
        if (!session.get('authenticated')) {
            return 'guest';
        }

        return session.get('admin') ? 'admin' : 'user';
    }

    _hasRole(role) {
        const roles = Array.isArray(role) ? role : [role];
        return roles.includes(this._getRole());
    }

    render() {
        /*eslint no-unused-vars: ["off", { "ignoreRestSiblings": true }]*/
        const { role, session, component, children, ...props } = this.props;

        if (!this._hasRole(role)) return null;
        if (!Array.isArray(children)) return children;

        return children.length === 1
            ? children
            : React.createElement(component, props, children);
    }
}

export default connect((state) => ({
    session: state.session,
}))(IsRole);
